export default {
  colors: {
    primary: '#3D3D4D',
    background: '#FFFFFF',
    shape: `#5ac5b7`,
    title: `#3D3D4D`,
    text: `#6C6C80`,
    components: {
      blockquote: {
        background: `#feebc8`,
        text: `#2d3748`,
      },
    },
  },
};
// #ea695b

// #5ac5b7
